import { isChannel } from "@website/utils/channel/helpers";
import { Header } from "@website/widget/header";
import { HeaderJek } from "@website/widget/header-jek";
import { MainHeaderPropertiesType } from "@website/widget/header-wrapper/header-wrapper.types";
import pick from "lodash-es/pick";
import { memo } from "react";

const MainHeader = (properties: MainHeaderPropertiesType) => {
  if (isChannel(["jek", "SNAPP_AD", "android"])) {
    return (
      <HeaderJek
        {...pick(properties, [
          "title",
          "showBackButton",
          "showAuth",
          "onProfileCLick",
          "showShareButton",
          "showPurchaseMenu",
          "showSupportButton"
        ])}
      />
    );
  }
  return (
    <Header
      {...pick(properties, [
        "customTitleText",
        "showMinimalLogo",
        "showSupportAgent",
        "showBackButton",
        "showAuth",
        "minimalView",
        "showMenuButton",
        "showDropShadow",
        "showBottomBorder",
        "showTravelServices",
        "showAgencies",
        "showTrackPurchase",
        "showDownloadApp",
        "state",
        "onBackButtonClick",
        "state"
      ])}
    />
  );
};
const MainHeaderMemoized = memo(MainHeader);
export { MainHeaderMemoized as HeaderWrapper };
